import '../../../jsscripts/jquery/jquery.variableitemwidthcarousel.js';
import $ from 'jquery';

const bloomReach = {
    _convertToListItem: function (item) {
        var $item = $(item);
        return '<li class="' + $item.attr('class') + '">' + $item.html() + '</li>';
    },
    _convertToList: function ($items) {
        return '<ul class="nav">' + $.map($items, this._convertToListItem).join('') + '</ul>';
    },
    _changeQuickViewLinks: function () {
        $('.br-sf-widget-merchant-qv > a').html('Learn More >');
    },
    _moveQuickViewProductLinks: function () {
        $('.br-sf-widget-merchant-popup-view').each(function (index, element) {
            var popup = $(element);
            popup.prev().append('<br>');
            popup.appendTo(popup.prev());
        });
    },
    updateHeadings: function () {
        $('.br-found-heading, .br-related-heading').each(function (index, heading) {
            $(heading).after(`<h2 class="${heading.className}">${heading.textContent}</h2>`).remove();
        });

        $('.br-sf-widget-merchant-popup-title').each(function (index, heading) {
            $(heading).after(`<h3 class="${heading.className} mtn">${heading.innerHTML}</h3>`).remove();
        });
    },
    wrapContentInSingleLink: function () {
        $('.br-sf-widget').each(function (index, element) {
            var $element = $(element),
                $links = $element.find('a:not([onclick])'),
                url = $links.eq(0).attr('href'),
                $describeLink;

            $links.each(function (index, link) {
                $(link).replaceWith(link.innerHTML);
            });

            $element
                .find('.br-sf-widget-merchant-img, .br-sf-widget-merchant-title')
                .wrapAll(`<a href="${url}" id="br-label-${index}"></a>`);

            $describeLink = $element.find('.br-sf-widget-merchant-qv a').eq(0);

            $describeLink
                .attr('id', `br-labelby-${index}`)
                .attr('aria-labelledby', `br-labelby-${index} br-label-${index}`);
        });

        $('.BRRelatedProducts').on('click', '.br-sf-widget-merchant-qv', (element) => {
            const $parent = $(element.target).closest('.br-sf-widget-merchant-cont');
            const prodID = parseInt($parent.find('a:first').attr('href').match(/\d+$/)[0]) + 10000;
            const prodName = $parent.find('.br-sf-widget-merchant-title').text().trim();

            if (window.BrTrk && window.BrTrk.getTracker()) {
                window.BrTrk.getTracker().logEvent('product', 'quickview', {'prod_id': prodID, 'prod_name': prodName});
            }
        });
    },

    makeCloseLinksAccessible: function () {
        $('.br-sf-widget-merchant-popup-close > a').each(function (index, link) {
            link.innerHTML = '<span class="br-close-text">Close</span><span class="br-close-x"></span>';
        });
    },
    _prepareImage: function ($img) {
        $img.loading = 'lazy';
        $img.width = 120;
        $img.height = 120;
        $img.alt = "";

        return $img;
    },
    _prepareTemplateContent: function ($template) {
        const $clone = $template.content.cloneNode(true);
        Array.from($clone.querySelectorAll('img')).forEach(img => this._prepareImage(img));
        $template.replaceWith($clone);
    },
    init: function ($element, itemSelector, numOfVisibleItems) {
        var $container = $($element),
            SMALL_SCREEN_VISIBLE = 2,
            $nav,
            $listItems,
            visibleItemCount,
            $template = $element.querySelector('#br-template');

        if ($template && $template.content) {
            this._prepareTemplateContent($template);
        }

        $container.append(this._convertToList($container.find(itemSelector).detach()));

        $nav = $container.find('.nav');
        $listItems = $nav.find('> li');

        this.wrapContentInSingleLink();
        this.updateHeadings();
        this.makeCloseLinksAccessible();

        if (smartPak.page.isSmallScreen()) {
            visibleItemCount = numOfVisibleItems || SMALL_SCREEN_VISIBLE;
            if ($listItems.length) {
                $listItems.width(Math.floor($container.outerWidth() / visibleItemCount));
                $nav.variableItemWidthCarousel();
            }

            this._changeQuickViewLinks();
            this._moveQuickViewProductLinks();
        } else if ($listItems.length) {
            $nav.variableItemWidthCarousel();
        }
    }
};

export default bloomReach;
